import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import {
  Alert, AlertsRepositoryServiceService, CorporationRepositoryService, EnumeratedTypesRepositoryService, ListComponent,
  TrackedAlertEntity, eAlertSeverity, eAlertStatus, severityClass, statusClass, trackedEntityDisplayName
} from 'reg-hub-common';
import { EnvironmentUrlService } from '../../../services/environment-url/environment-url.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrl: './alerts.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AlertsComponent extends ListComponent<Alert> implements OnInit {
  // The client portal's columns, plus Corporation first since admins see every client's alerts
  columnsToDisplay: string[] = [
    'corporation',
    'alertSeverityID',
    'alertTypeID',
    'subject',
    'description',
    'alertStatusID',
    'added',
    'view'];

  private corporationNames = new Map<string, string>();
  private alertTypeNames = new Map<string, string>();

  constructor(
    repo: AlertsRepositoryServiceService,
    private router: Router,
    private environment: EnvironmentUrlService,
    private corporationsRepo: CorporationRepositoryService,
    private enumeratedTypesRepo: EnumeratedTypesRepositoryService
  ) {
    super(repo);
    this.repo = repo;
  }

  ngOnInit(): void {
    this.corporationsRepo.getCorporationsAsSelectOptions().pipe(catchError(() => of([])))
      .subscribe(corporations => corporations.forEach(c => this.corporationNames.set(c.value as string, c.label)));

    this.enumeratedTypesRepo.getAlertTypes(this.environment.urlAddress).pipe(catchError(() => of([])))
      .subscribe(types => types.forEach(t => this.alertTypeNames.set(t.id, t.name)));
  }

  // Falls back to the ID until the names load, or if the corporation isn't in the list
  corporationName(alert: Alert): string {
    return this.corporationNames.get(alert.corporationID) ?? alert.corporationID;
  }

  alertTypeName(alert: Alert): string {
    return this.alertTypeNames.get(alert.alertTypeID) ?? alert.alertTypeID;
  }

  subject(entity: TrackedAlertEntity): string {
    return trackedEntityDisplayName(entity);
  }

  severityClass(severity: eAlertSeverity): string {
    return severityClass(severity);
  }

  statusClass(status: eAlertStatus): string {
    return statusClass(status);
  }

  protected viewAlert(alert: Alert, newTab: boolean) {
    if (newTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['alerts', alert.id])
      );

      window.open(url, '_blank');
    }
    else {
      this.router.navigate(['alerts', alert.id]);
    }
  }
}
